import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import HtltService from '../../components/services/htlt'

const HTLT = () => {

    const faqSchema4 = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What industries do you serve as industrial electrical contractors in India?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We work with manufacturing plants, warehouses, logistics hubs, commercial infrastructure, and specialised industrial facilities."
    }
  },{
    "@type": "Question",
    "name": "How do you ensure safety during live electrical installations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We follow strict isolation procedures, phased shutdown planning, and continuous supervision during all site activities."
    }
  },{
    "@type": "Question",
    "name": "Do you support future expansion during electrical design?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, our designs include capacity planning, spare provisions, and access considerations for future growth."
    }
  },{
    "@type": "Question",
    "name": "How do you coordinate with other engineering disciplines on site?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "We collaborate closely with mechanical, fire safety, and automation teams through integrated planning and regular coordination reviews."
    }
  },{
    "@type": "Question",
    "name": "Do you provide documentation after project completion?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, we hand over complete drawings, test reports, and compliance records for maintenance and audits."
    }
  }]


    };

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Helmet>
<title>Industrial Electrical Contractors in India | Unique Engineers</title>
<meta name="description" content="Industrial electrical contractors in India delivering turnkey electrical services, testing & commissioning for industry clients. Trust Unique Engineers for quality." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/industrial-electrical-contractors-in-india/" />

        <script type="application/ld+json">
                    {JSON.stringify(faqSchema4)}
                </script>    
            
            </Helmet>
             <Banner img={'/assets/images/electrical-banner.jpg'} title= 'React out and Connect' />
            <HtltService />
        </Grid>
    )

}

export default HTLT;